import moment from 'moment';
import report from '../../../apis/report';
import { DayWiseFeeBookReportProps } from '../types';
import isEmpty from 'lodash/isEmpty';
import { DayWiseFeeBookReportFilters } from '../../../types/ReportType';

const fetchDayWiseFeeBookReport = async (
  params: DayWiseFeeBookReportFilters
) => {
  const usersDayWiseFeeBookReport: any[] = [];
  const perPage = 200;
  let pageNo = 1;
  const BATCH_SIZE = 3;
  let hasMoreData = true;

  do {
    const pagePromises = [];
    for (let i = 0; i < BATCH_SIZE; i++) {
      pagePromises.push(
        report.fetchDayWiseFeeBookReportApi({
          ...params,
          perPage,
          pageNo: pageNo + i
        })
      );
    }

    const batchResults = await Promise.all(pagePromises);

    let foundEmpty = false;
    batchResults.forEach((result) => {
      if (isEmpty(result)) {
        foundEmpty = true;
        return;
      }
      usersDayWiseFeeBookReport.push(...(result as any));
    });

    if (foundEmpty) {
      hasMoreData = false;
    } else {
      pageNo += BATCH_SIZE;
    }
  } while (hasMoreData);

  return usersDayWiseFeeBookReport;
};

const transformDayWiseFeeBookReport = (
  feeBookData: DayWiseFeeBookReportProps[]
) => {
  const DATE_FORMAT = 'DD-MMM-YYYY';
  let srNo = 0;
  return feeBookData.map((record) => {
    srNo++;
    const baseData = {
      'Sr. No.': srNo,
      'Created By': record.updatedByUser?.email || '',
      'Student Name': record.studentDetails?.name || '',
      'Enrollment No': record.studentDetails?.enrollmentNo || '',
      Session: record.academicYear || '',
      Grade: record.grade || '',
      Division: record.division || '',
      Particulars: record.particulars || '',
      Period: record.feePeriod || '',
      'Mode Of Payment': record.modeOfPayment || '',
      'Payment Status': record.status || '',
      'Amount Paid': record.amount || 0,
      'Transaction Id': record.transactionId || '',
      'Receipt No': record.receiptNo || '',
      'Cheque Issue Date': record.chequeDetails
        ? moment(record.chequeDetails.issueDate).format(DATE_FORMAT)
        : '',
      'Cheque No': record.chequeDetails?.chequeNo || '',
      'Bank Name': record.chequeDetails?.bank || '',
      'Branch Name': record.chequeDetails?.branch || '',
      'Cheque Deposit Date': record.chequeDepositDate || '',
      'Cheque Cleared Date': record.chequeClearedDate || '',
      'Cheque Bounced Date': record.chequeBouncedDate || '',
      'Payment Cancelled Date': record.paymentCancelledDate || '',
      Remarks: record.remark || '',
      'Receipt Centre Account': record.school || '',
      'Date Of Entry': moment(record.createdAt).format(DATE_FORMAT) || '',
      'Payment Date': moment(record.paymentDate).format(DATE_FORMAT) || ''
    };
    return baseData;
  });
};

export { fetchDayWiseFeeBookReport, transformDayWiseFeeBookReport };
